<template>
  <!--  第二、三屏-->
  <div class="sercontent">
    <div class="contentbody">
      <div class="texttitle" v-html="namebot">
        <p class="wow slideInLeft">{{namebot}}</p>
      </div>
      <div class="imgdiv wow slideInRight">
        <img class="" :src="imgsrcbot">
      </div>
    </div>
    <div class="contentbody">
      <div class="imgdiv wow slideInLeft">
        <img :src="imgsrctop">
      </div>
      <div class="texttitle " v-html="nametop">
        <p class="wow fadeInUp">{{nametop}}</p>
      </div>
    </div>


  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "sercontent",
    props: ['nametop', 'namebot', 'imgsrctop', 'imgsrcbot'],
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
  }
</script>

<style lang="less" scoped>
  // 大于800px
  @media only screen and (min-width: 800px) {
    .sercontent {
      width: 100%;
      height: 100%;
      font-size: 1em;
      margin-bottom: -0.3%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;

      .contentbody {
        width: 90%;
        margin-top: -3px;
        display: flex;
        align-items: center;

        div:nth-child(1) {
          float: left;
        }

        div:nth-child(2) {
          float: right;
        }

        .imgdiv {
          width: 50%;
          height: 50%;
          /*background: #200A42;*/
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .texttitle {
          width: 50%;
          height: 50%;
          color: black;
          font-size: 2.5em;

          h1 {
            padding: 0 40px;
            font-weight: initial;

          }
        }

      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px) {
    .sercontent {
      width: 100%;
      height: 100%;
      font-size: 1em;
      margin-bottom: -0.3%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;

      .contentbody {
        width: 90%;
        margin-top: -3px;
        display: flex;
        align-items: center;

        div:nth-child(1) {
          float: left;
        }

        div:nth-child(2) {
          float: right;
        }

        .imgdiv {
          width: 50%;
          height: 50%;
          /*background: #200A42;*/
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .texttitle {
          width: 50%;
          height: 50%;
          color: black;
          font-size: 2em;

          h1 {
            padding: 0 40px;
            font-weight: normal;

          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Services/sercomponents/Sercontent.vue